/*
  VAIROK · fecha de entrega estimada en la ficha (snippets/vk-pdp-eta.liquid). Decisión de Marc, 26/10/2026.

  · Plegado: el método rápido del país (UPS Express en DE/FR/…, Correos Express en ES/PT) con su fecha, sin precio.
    Abierto: todos los métodos del país, cada uno con su fecha y su precio.
  · País: por IP (/browsing_context_suggestions.json, guardado en sessionStorage). Mientras llega, se supone por
    el idioma (de → DE, fr → FR, es → ES). En inglés espera a la IP. País sin envío o moneda que no sea EUR: no se ve.
  · En /de y /fr nunca salen los envíos de España (Marc, 26/10/2026): la IP solo cuenta si es de la misma zona
    (Alemania, Francia, Austria…); si no, se queda Alemania o Francia. Así un alemán con IP española (de viaje,
    con VPN o mal detectada) ve los envíos de Alemania. En /es y /en manda la IP.
  · Salida: pedido antes de las 11:00 (hora de Madrid) en día laborable → sale ese día; si no, el siguiente laborable.
  · Laborable: de lunes a viernes, sin festivos nacionales de España ni de Cataluña (sale de Sabadell)
    ni los nacionales del destino (Alemania y Francia). El día de salida solo mira los de España.
  · Precio: con 2 luces se pasa del mínimo de envío gratis (vk:qty-change de vk-pdp.js) y cambia la tarifa.
  Para probar: ?vk_now=2026-10-30T12:00 (hora de Madrid) y ?vk_country=DE.
*/
(function () {
  'use strict';

  var CUTOFF_HOUR = 11;
  var TZ = 'Europe/Madrid';

  // Tarifas de Shopify (Ajustes › Envíos, «General profile», leídas el 26/10/2026), en céntimos:
  // [por debajo del mínimo de envío gratis, desde el mínimo]. Si cambian en Shopify, cambiarlas aquí.
  // days: días laborables desde la salida [mínimo, máximo] (Marc, 26/10/2026; UPS «realmente 2-3 días»).
  // El primero es el que sale plegado.
  var ZONES = [
    {
      countries: ['DE', 'FR', 'AT', 'BE', 'NL', 'LU', 'IT', 'CH'],
      methods: [
        { key: 'ups_express', icon: 'bolt', price: [650, 390], days: [2, 3] },
        { key: 'standard', icon: 'truck', price: [390, 0], days: [3, 7] }
      ]
    },
    {
      countries: ['ES', 'PT'],
      methods: [
        { key: 'correos_express', icon: 'bolt', price: [390, 190], days: [1, 1] },
        { key: 'standard', icon: 'truck', price: [250, 50], days: [2, 3] },
        { key: 'pickup', icon: 'pin', price: [190, 0], days: [2, 3] }
      ]
    }
  ];
  var LANG_COUNTRY = { de: 'DE', fr: 'FR', es: 'ES' };

  // Festivos fijos (MM-DD) y móviles (días respecto al domingo de Pascua).
  // es: nacionales + Cataluña (Lunes de Pascua, Sant Joan, Diada, Sant Esteve).
  var FIXED = {
    es: ['01-01', '01-06', '05-01', '06-24', '08-15', '09-11', '10-12', '11-01', '12-06', '12-08', '12-25', '12-26'],
    de: ['01-01', '05-01', '10-03', '12-25', '12-26'],
    fr: ['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25']
  };
  var MOVING = { es: [-2, 1], de: [-2, 1, 39, 50], fr: [1, 39, 50] };

  var ICONS = {
    bolt: '<path d="M13.25 2.75 5.5 13.25h6l-1 8 8-11h-6z"/>',
    truck: '<path d="M2.75 6.25h10.5v9.5H2.75z"/><path d="M13.25 9.25h4.25l3.75 3.75v2.75h-8"/>' +
      '<circle cx="6.75" cy="16.75" r="1.9" fill="#fff"/><circle cx="17.25" cy="16.75" r="1.9" fill="#fff"/>',
    pin: '<path d="M12 21s-6.5-6.2-6.5-11a6.5 6.5 0 0 1 13 0c0 4.8-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>'
  };

  function ymd(d) { return d.toISOString().slice(0, 10); }
  function addDays(d, n) { var r = new Date(d); r.setUTCDate(r.getUTCDate() + n); return r; }

  // Domingo de Pascua (algoritmo de Meeus/Jones/Butcher)
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var n = h + l - 7 * m + 114;
    return new Date(Date.UTC(y, Math.floor(n / 31) - 1, (n % 31) + 1));
  }

  var cache = {};
  function holidays(y, country) {
    var key = country + y;
    if (cache[key]) return cache[key];
    var set = {};
    var e = easter(y);
    (FIXED[country] || []).forEach(function (md) { set[y + '-' + md] = true; });
    (MOVING[country] || []).forEach(function (n) { set[ymd(addDays(e, n))] = true; });
    cache[key] = set;
    return set;
  }

  function isWorkday(d, dest) {
    var wd = d.getUTCDay();
    if (wd === 0 || wd === 6) return false;
    var y = d.getUTCFullYear(), k = ymd(d);
    if (holidays(y, 'es')[k]) return false;
    return !(dest && holidays(y, dest)[k]);
  }
  function nextWorkday(d, dest) {
    do { d = addDays(d, 1); } while (!isWorkday(d, dest));
    return d;
  }
  function plusWorkdays(d, n, dest) {
    while (n-- > 0) d = nextWorkday(d, dest);
    return d;
  }

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&]+)').exec(location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }

  // Fecha y hora de Madrid, como día en UTC (sin líos con el cambio de hora)
  function madridNow() {
    var q = param('vk_now');
    if (q) {
      var p = q.split(/[-T:]/).map(Number);
      return { date: new Date(Date.UTC(p[0], p[1] - 1, p[2])), hour: p[3] || 0 };
    }
    var parts = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (x) { parts[x.type] = x.value; });
    return { date: new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day)), hour: +parts.hour };
  }

  function shipDay() {
    var now = madridNow();
    var ship = now.date;
    if (!isWorkday(ship) || now.hour >= CUTOFF_HOUR) ship = nextWorkday(ship);
    return ship;
  }

  function zoneFor(country) {
    for (var i = 0; i < ZONES.length; i++) {
      if (ZONES[i].countries.indexOf(country) !== -1) return ZONES[i];
    }
    return null;
  }

  function fmtRange(from, to, lang) {
    var f = new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    if (ymd(from) === ymd(to)) return f.format(from);
    if (from.getUTCFullYear() === to.getUTCFullYear() && f.formatRange) return f.formatRange(from, to);
    return f.format(from) + ' – ' + f.format(to);
  }

  function svg(name, cls) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
      ICONS[name] + '</svg>';
  }
  function node(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function init(el) {
    var cfg;
    try { cfg = JSON.parse(el.querySelector('[data-vk-eta-config]').textContent); } catch (e) { return; }
    if (cfg.currency !== 'EUR') return;

    var lang = cfg.lang;
    var money = new Intl.NumberFormat(lang, { style: 'currency', currency: 'EUR' });
    var sep = lang === 'fr' ? ' : ' : ': ';
    var country = '';
    var qty = 1;

    function draw() {
      var zone = zoneFor(country);
      if (!zone) { el.hidden = true; return; }
      var dest = country.toLowerCase();
      var ship = shipDay();
      var over = cfg.price * qty >= cfg.threshold ? 1 : 0;
      var list = el.querySelector('[data-vk-eta-list]');
      list.textContent = '';

      zone.methods.forEach(function (m, i) {
        var when = fmtRange(plusWorkdays(ship, m.days[0], dest), plusWorkdays(ship, m.days[1], dest), lang);
        var name = cfg.labels[m.key] || m.key;
        var cents = m.price[over];
        if (i === 0) {
          el.querySelector('[data-vk-eta-icon]').innerHTML = svg(m.icon, 'vk-eta__ic');
          el.querySelector('[data-vk-eta-name]').textContent = name + sep;
          el.querySelector('[data-vk-eta-date]').textContent = when;
        }
        var row = node('div', 'vk-eta__row');
        row.insertAdjacentHTML('beforeend', svg(m.icon, ''));
        var text = node('span');
        text.appendChild(node('span', 'vk-eta__when', when));
        text.appendChild(node('span', 'vk-eta__name', name));
        row.appendChild(text);
        row.appendChild(node('span', 'vk-eta__price', cents ? money.format(cents / 100) : cfg.labels.free));
        list.appendChild(row);
      });
      el.hidden = false;
    }

    // En /de y /fr, la IP solo cuenta si cae en la zona de Alemania y Francia: nunca los envíos de España.
    var langCountry = LANG_COUNTRY[lang];
    var lockedZone = lang === 'de' || lang === 'fr' ? zoneFor(langCountry) : null;

    function setCountry(c) {
      c = (c || '').toUpperCase();
      if (lockedZone && zoneFor(c) !== lockedZone) c = langCountry;
      if (!c || c === country) return;
      country = c;
      draw();
    }

    document.addEventListener('vk:qty-change', function (e) {
      qty = e.detail && e.detail.quantity ? e.detail.quantity : 1;
      if (country) draw();
    });

    var forced = param('vk_country');
    if (forced) { setCountry(forced); return; }

    setCountry(langCountry);
    var KEY = 'vk-eta-country';
    var stored = null;
    try { stored = sessionStorage.getItem(KEY); } catch (e) {}
    if (stored) { setCountry(stored); return; }
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!c) return;
        try { sessionStorage.setItem(KEY, c); } catch (e) {}
        setCountry(c);
      })
      .catch(function () {});
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-vk-eta]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
